class SubscriptionUser{
    constructor(){
        this.susbcriptionform = document.getElementById('emailForm')
        this.closeMessageWindow = document.getElementById('closeMessage')
        this.message = document.getElementById('successMessage')
        this.submitemail = document.getElementById('submitEmailSubs')
        this.events()
        
    }
    events(){
        document.addEventListener('keyup', (event)=>{if(event.ctrlKey && event.key === 'R' || event.ctrlKey && event.key === 'r' || event.ctrlKey && event.shiftKey && event.key === 'R' || event.key === 'r' || event.key === 'R'){event.preventDefault()}})
        window.history.pushState(null, null, window.location.href);
        
        this.message(addEventListener('click',()=>{
            this.message.style.display = 'none'
            window.history.replaceState( null, null, window.location.href );
            
        }))
        
        if(window.history.replaceState ){
            window.history.replaceState( null, null, window.location.href );
            
        }
        
          
          
       
    }

    
}

export default SubscriptionUser